window.addEventListener("DOMContentLoaded", (event) => { 

      document.querySelectorAll('.truncate__text-wrapper').forEach(container => {
        const textContent = container.querySelector('.text-content');
        const toggleBtn = container.querySelector('.read-more__toggler');
        const fullText = container.getAttribute('data-full-text');
        const truncatedText = container.getAttribute('data-truncated-text');

        if (toggleBtn) {
            toggleBtn.addEventListener('click', () => {
                if (container.classList.contains('expanded')) {
                    container.classList.remove('expanded');
                    textContent.innerHTML = truncatedText;
                    toggleBtn.textContent = 'Read More';
                } else {
                    container.classList.add('expanded');
                    textContent.innerHTML = fullText;
                    toggleBtn.textContent = 'Read Less';
                }
                // Append button after the text content
                textContent.append(toggleBtn);
            });
        }
    });

});



// SHIPPING PAGE
document.addEventListener('DOMContentLoaded', function () {
  var accordion = document.querySelector('.shipping-accordion');
  if (!accordion) return; // no accordion on this page

  var items = accordion.querySelectorAll('.shipping-item');

  items.forEach(function (item) {
    var header = item.querySelector('.shipping-header');
    if (!header) return;

    header.addEventListener('click', function () {
      items.forEach(function (other) {
        if (other !== item) {
          other.classList.remove('active');
        }
      });

      item.classList.toggle('active');
    });
  });
});